import { shape, string } from 'prop-types'
import queryString from 'query-string'
import { withRouter } from 'react-router-dom'

export function withQueryParams(WrappedComponent) {
  const WithQueryParams = ({ location, ...props }) => (
    <WrappedComponent query={queryString.parse(location.search)} {...props} />
  )

  WithQueryParams.propTypes = {
    location: shape({
      search: string.isRequired,
    }).isRequired,
  }

  return withRouter(WithQueryParams)
}
